import React, { useState } from 'react';
import { outlineApi } from '../../api/outlines';
import Modal from '../Common/Modal';
import Button from '../Common/Button';
import './Outline.css';

export function WorkshopCreator({ section, onClose, onCreated }) {
  const [name, setName] = useState(`Workshop: ${section?.display_name || ''}`);
  const [description, setDescription] = useState('');
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Name is required');
      return;
    }

    if (!section?.id) {
      setError('Section ID is missing');
      console.error('Section missing ID:', section);
      return;
    }

    try {
      setCreating(true);
      setError(null);
      console.log('Creating workshop for section:', section.id, section.display_name);
      const response = await outlineApi.createWorkshop(
        section.id,
        name.trim(),
        description.trim() || null
      );
      onCreated(response.data);
    } catch (err) {
      const errorMessage = err.message || 'Failed to create workshop';
      setError(errorMessage);
      console.error('Workshop creation error:', err);
    } finally {
      setCreating(false);
    }
  };

  return (
    <Modal isOpen={true} onClose={onClose} title="Create Workshop Session">
      <form onSubmit={handleSubmit} className="workshop-creator">
        <div className="workshop-creator__section-info">
          <span className="workshop-creator__section-label">For section:</span>
          <span className="workshop-creator__section-name">{section?.display_name}</span>
        </div>

        {error && <div className="workshop-creator__error">{error}</div>}

        <div className="workshop-creator__field">
          <label htmlFor="workshop-name">Session Name</label>
          <input
            id="workshop-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter workshop name"
            autoFocus
          />
        </div>

        <div className="workshop-creator__field">
          <label htmlFor="workshop-description">Description (optional)</label>
          <textarea
            id="workshop-description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="What will you brainstorm in this session?"
            rows={3}
          />
        </div>

        <div className="workshop-creator__actions">
          <Button type="button" onClick={onClose} variant="secondary">
            Cancel
          </Button>
          <Button type="submit" disabled={creating} variant="primary">
            {creating ? 'Creating...' : 'Create Workshop'}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export default WorkshopCreator;
